import React, { useEffect } from 'react';

import * as CONSTANTS from "../constants";

import OrderSummary from '../components/order-summary';
import IFrame from '../components/iframe';

const iframeURL = `${CONSTANTS.DOMAIN_NAME}/${CONSTANTS.CLIENT_NAME}/website/secure/checkout/v2?resize=true`;

export default function Checkout() {

    return (
      <div className='booking-pathway__container booking-pathway__checkout'>
            
            <div className='booking-pathway__main-content'>
                <h1 className='sr-text'>Checkout</h1>

                <div className="booking-pathway__checkout-frame">
                    <IFrame url={iframeURL} title="Checkout" hasLoader="true" />
                </div>
            </div>

            <div className='booking-pathway__footer'>
                <OrderSummary />
            </div>
        </div>
    );
  }